// extracted by mini-css-extract-plugin
export default {"badge":"DateBadge_badge__PqpNm"};